import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FiArrowRight, FiArrowDown } from 'react-icons/fi';
import './Hero.css';

const Hero = () => {
  const { t } = useTranslation();

  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="hero bg-gradient">
      {/* Animated Background Elements */}
      <div className="hero-bg-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
        <div className="shape shape-5"></div>
        <div className="grid-pattern"></div>
      </div>

      <div className="container hero-content">
        <motion.div
          className="hero-text"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <motion.div
            className="hero-badge"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <span className="badge-dot"></span>
            {t('hero.badge')}
          </motion.div>

          <h1 className="hero-title">
            {t('hero.title1')}
            <br />
            <span className="gradient-text">{t('hero.title2')}</span>
          </h1>

          <p className="hero-subtitle">{t('hero.subtitle')}</p>

          <div className="hero-cta">
            <motion.button
              className="btn btn-primary btn-lg"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => scrollTo('#contact')}
            >
              {t('hero.cta1')}
              <FiArrowRight />
            </motion.button>
            <motion.button
              className="btn btn-outline btn-lg"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => scrollTo('#services')}
            >
              {t('hero.cta2')}
              <FiArrowDown />
            </motion.button>
          </div>

          <div className="hero-stats">
            <div className="hero-stat">
              <strong>500+</strong>
              <span>{t('hero.stats.projects')}</span>
            </div>
            <div className="hero-stat-divider"></div>
            <div className="hero-stat">
              <strong>200+</strong>
              <span>{t('hero.stats.clients')}</span>
            </div>
            <div className="hero-stat-divider"></div>
            <div className="hero-stat">
              <strong>18+</strong>
              <span>{t('hero.stats.years')}</span>
            </div>
          </div>
        </motion.div>

        <motion.div
          className="hero-visual"
          initial={{ opacity: 0, x: 60 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          <div className="hero-illustration">
            <div className="floating-card card-1">
              <div className="card-icon" style={{ background: 'linear-gradient(135deg, #5cb0dd, #3a95c9)' }}>
                <span>{'</>'}</span>
              </div>
              <div className="card-info">
                <small>{t('hero.cards.web')}</small>
                <div className="card-bar"><div className="card-bar-fill" style={{ width: '90%' }}></div></div>
              </div>
            </div>

            <div className="floating-card card-2">
              <div className="card-icon" style={{ background: 'linear-gradient(135deg, #8b5cf6, #6d28d9)' }}>
                <span>📱</span>
              </div>
              <div className="card-info">
                <small>{t('hero.cards.mobile')}</small>
                <div className="card-bar"><div className="card-bar-fill" style={{ width: '85%', background: '#8b5cf6' }}></div></div>
              </div>
            </div>

            <div className="floating-card card-3">
              <div className="card-icon" style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)' }}>
                <span>☁️</span>
              </div>
              <div className="card-info">
                <small>{t('hero.cards.cloud')}</small>
                <div className="card-bar"><div className="card-bar-fill" style={{ width: '95%', background: '#f59e0b' }}></div></div>
              </div>
            </div>

            <div className="hero-circle-decoration">
              <svg viewBox="0 0 200 200" className="circle-svg">
                <circle cx="100" cy="100" r="90" fill="none" stroke="rgba(92,176,221,0.2)" strokeWidth="1" />
                <circle cx="100" cy="100" r="70" fill="none" stroke="rgba(92,176,221,0.15)" strokeWidth="1" strokeDasharray="10 5" />
                <circle cx="100" cy="100" r="50" fill="none" stroke="rgba(92,176,221,0.1)" strokeWidth="1" />
              </svg>
            </div>
          </div>
        </motion.div>
      </div>

      <div className="hero-scroll-indicator" onClick={() => scrollTo('#services')}>
        <div className="scroll-mouse">
          <div className="scroll-wheel"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
